// Usage: This general purpose controller can be used to fetch data from a
// a server and then dispatch an event with that data attached.
//
// Example:
//
// Fetch the data
// <div data-controller="data-updater"
//      data-event-key="notice-data-fetched"
//      data-url="/api/v1/notices.json?user_id=1">
// </div>
//
// Respond to the event
// <div data-action="notice-data-fetched@document->chart#updateData">
// </div>
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    eventKey: String,
    url: String,
    arrayData: Array,
    hashData: Object,
  }

  connect() {
    setTimeout(() => {
      if (this.hasEventKeyValue && this.hasHashDataValue) {
        document.dispatchEvent(
          new CustomEvent(this.eventKeyValue, {
            detail: {
              data: this.hashDataValue
            },
          }),
        );
      }

      if (this.hasEventKeyValue && this.hasArrayDataValue) {
        document.dispatchEvent(
          new CustomEvent(this.eventKeyValue, {
            detail: {
              data: this.arrayDataValue
            },
          }),
        );
      }

      if (this.hasEventKeyValue && this.hasUrlValue) {
        $.getJSON(this.urlValue, (data) => {
          document.dispatchEvent(
            new CustomEvent(this.eventKeyValue, {
              detail: {
                data: data
              },
            }),
          );
        });
      }
    });
  }
}
